// Core imports
import * as React from 'react';

// Style and Misc imports
import './SortCard.scss';

const SortCard = (props: ISortCardProps) => {
  const returnActiveCheck = () => {
    if (props.active) {
      return <i className="rpds-check-circle" />;
    } else {
      return <React.Fragment />;
    }
  };

  return (
    <div
      className="rp-sort-card"
      onClick={() => {
        props.setSort(props.sort);
      }}
    >
      <p>{props.sort.label}</p>
      {returnActiveCheck()}
    </div>
  );
};

export default SortCard;

interface ISortCardProps {
  setSort(sort: ISort): void;
  sort: ISort;
  active: boolean;
}

interface ISort {
  sortBy: string;
  sortIn: 'asc' | 'desc';
  label: string;
}
